import { KYMW7002Component } from './kymw7002.component';
import { SelectedGoodsFlgResult } from './vo/selected-goods-flg-result.model';
import { SuggestionGoods } from './vo/suggestion-goods.model';

import type { CandidateSuggestionGoods } from './vo/candidate-suggestion-goods.model';

/** 親画面「特集商品提案状況確認画面（取引先用）」ID */
export const PARENT_PAGE_ID = 'kymw/7003';
/** リスト表示エリアのページ単位件数 */
export const COUNT_PER_PAGE = 100;

/** 媒体区分「在庫限定」 */
export const MEDIUM_TYPE_STOCK_ONLY = '018';
/** 承認フロー区分「特集付け替え」 */
export const APPROVAL_FLOW_TYPE_FEATURE_REPLACEMENT = '1';

/**
 * ログインユーザ区分
 *
 * @export KYMW1001UserType
 * @enum KYMW1001UserType
 */
export const enum KYMW1001UserType {
  /** 取引先(卸) */
  WHOLESALE = '取引先(卸)',
  /** 企画支援 */
  PLANNING_SUPPORT = '企画支援',
}

/**
 * 選定担当区分
 *
 * @export KYMW7002SelectorType
 * @enum KYMW7002SelectorType
 */
export const enum KYMW7002SelectorType {
  /** 取引先(卸) */
  WHOLESALE = 3,
  /** 企画支援 */
  PLANNING_SUPPORT = 1,
}

/**
 * 表示区分
 *
 * @export KYMW7002ViewType
 * @enum KYMW7002ViewType
 */
export const enum KYMW7002ViewType {
  /** 新規提案 */
  CREATE = '0',
  /** 履歴確認 */
  HISTORY = '1',
}

/**
 * 商品選定済みフラグ
 *
 * @export KYMW7002SelectionFlg
 * @enum KYMW7002SelectionFlg
 */
export const enum KYMW7002SelectionFlg {
  /** 未選択 */
  UNSELECTED = '0',
  /** 一時保存 */
  DRAFT = '1',
  /** 選択済み */
  SELECTED = '2',
}

/**
 * 価格パターン 設定値
 *
 * @export KYMW7002PricePatternValue
 * @enum KYMW7002PricePatternValue
 */
export const enum KYMW7002PricePatternValue {
  /** 通常価格 */
  STANDARD = '0',
  /** 特価1 */
  SPECIAL1 = '1',
  /** 特価2 */
  SPECIAL2 = '2',
  /** 特価3 */
  SPECIAL3 = '3',
}
export const PricePatternList: {value: KYMW7002PricePatternValue, label: string}[] = [
  { value: KYMW7002PricePatternValue.STANDARD, label: '通常価' },
  { value: KYMW7002PricePatternValue.SPECIAL1, label: '特１' },
  { value: KYMW7002PricePatternValue.SPECIAL2, label: '特２' },
  { value: KYMW7002PricePatternValue.SPECIAL3, label: '特３' },
];
/**
 * 発注単位区分 デフォルト値の設定ためバラのみ定義
 */
export const enum KYMW7002OrderUnitType {
  /** バラ */
  INDIVIDUALLY = '0',
}
/**
 * 新規区分 設定値
 *
 * @export KYMW7002NewUnitType
 * @enum KYMW7002NewUnitType
 */
export const enum KYMW7002NewUnitType {
  /** 新規 */
  NEW = '0',
  /** 既存 */
  EXISTING = '1',
}
export const NewUnitTypeList: {value: KYMW7002NewUnitType, label: string}[] = [
  { value: KYMW7002NewUnitType.NEW, label: '新規' },
  { value: KYMW7002NewUnitType.EXISTING, label: '既存' },
];

/**
 * 特集商品提案画面の値を管理するクラス
 *
 * @export KYMW7002Model
 * @class KYMW7002Model
 */
export class KYMW7002Model {
  kymw7002Component: KYMW7002Component;

  // ユーザ区分
  userType: string = '';
  // 取引先コード
  supplierCode: string = '';
  // ユーザID
  userID: string = '';
  // ユーザID
  planningSupportFlg: string = '';

  // 表示区分
  viewType: KYMW7002ViewType = KYMW7002ViewType.CREATE;

  // 企画回
  catalogId: string = '';
  // 受注コード
  orderCode: string = '';
  // 媒体区分
  mediumType: string = '';
  // 媒体名
  mediumName: string = '';
  // 特集コード
  featureCode: string = '';
  // 特集名
  featureName: string = '';
  // 特集
  feature: string = '';

  // 特集商品提案状況一覧
	selectedGoodsFlgResult: SelectedGoodsFlgResult = {} as SelectedGoodsFlgResult;
  // 提案商品
  suggestionGoods: SuggestionGoods = {} as SuggestionGoods;
  // 承認フロー区分
  approvalFlowType: string = '';
  // 帳票出力ファイル名（実際にはファイルパス）
  outputFileName: string = '';

  // 提案候補商品一覧
  candidateSuggestionGoodsAllList: CandidateSuggestionGoods[] = [] as CandidateSuggestionGoods[];
  candidateSuggestionGoodsPageList: CandidateSuggestionGoods[] = [] as CandidateSuggestionGoods[];
  // 提案候補商品一覧用
  totalNumCandidateList: number = 0;                        // 検索結果の総件数
  currentPageNoCandidateList: number = 1;                   // 検索結果の現在ページ番号
  endPageNoCandidateList: number = 1;                       // 検索結果の最終ページ番号
  startDispNumCandidateList: number = 0;
  endDispNumCandidateList: number = 0;
  // 提案候補商品一覧 非表示フラグ
  isHiddenCandidateList: boolean = false;

  // 提案商品一覧
  suggestionGoodsAllList: SuggestionGoods[] = [] as SuggestionGoods[];
  suggestionGoodsPageList: SuggestionGoods[] = [] as SuggestionGoods[];

  //発注区分
  orderUnitTypeList: {label: string; value: string }[] = [];
  orderUnitTypeListSearchData = [] as any[];


  // 提案商品一覧用
  totalNumSuggestList: number = 0;                          // 検索結果の総件数
  currentPageNoSuggestList: number = 1;                     // 検索結果の現在ページ番号
  endPageNoSuggestList: number = 1;                         // 検索結果の最終ページ番号
  startDispNumSuggestList: number = 0;                      // 検索結果の開始表示件数
  endDispNumSuggestList: number = 0;                        // 検索結果の終了表示件数
  isEditableColumnSuggestList: boolean = true;              // 一覧のカラム編集可否フラグ
  // 項目の表示/非表示フラグ（提案商品一覧）
  isVisibleColumnCostPriceStandard: boolean = true;         // 仕入価格(通常) 表示フラグ
  isVisibleColumnThisTimeCostPriceStandard: boolean = true; // 今回仕入価格 表示フラグ
  isVisibleColumnStockNumd: boolean = true;                 // 在庫数 表示フラグ
  isVisibleColumnOrderUnitType: boolean = true;             // 発注単位 表示フラグ
  isVisibleColumnNewUnitType: boolean = true;               // 新規区分 表示フラグ
  isVisibleColumnPlanNum: boolean = true;                   // 計画数 表示フラグ
  isVisibleColumnOrderNum: boolean = true;                  // 注文番号 表示フラグ

  // 各非活性フラグ
  isDisableButtonSearchGoods: boolean = false;              // 商品検索ボタン 非活性フラグ
  isDisableButtonToggleView: boolean = false;               // 表示切替ボタン 非活性フラグ
  isDisableButtonSelectGoods: boolean = false;              // 選定ボタン 非活性フラグ
  isDisableButtonCancelSelection: boolean = false;          // 選定解除ボタン 非活性フラグ
  isDisableButtonSaveTemporary: boolean = false;            // 一時保存ボタン 非活性フラグ
  isDisableButtonSuggest: boolean = false;                  // 提案ボタン 非活性フラグ
  isDisableButtonOutput: boolean = false;                   // 一覧出力ボタン 非活性フラグ
  isDisableGridColumnsCandidateList: boolean = false;       // 提案候補商品一覧用 各項目 非活性フラグ
  isDisableGridColumnsSuggestList: boolean = false;         // 提案商品一覧用 各項目 非活性フラグ
}
